import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { useMemo, useRef, useEffect, useCallback } from 'react';
import qs from 'query-string';
import useConstant from './useConstant.es.js';
import { a as makeParamsEncDec } from './encdec.es.js';
import useMemoCompare from './useMemoCompare.es.js';
import './utils.es.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/typeof';
import 'memoize-one';
import 'fast-deep-equal';

function useQueryParams(queryString, setQueryString, qpEncoder) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var parser = useConstant(function () {
    return makeParamsEncDec(qpEncoder);
  });
  var opts = useMemoCompare(options);
  var queryParams = useMemo(function () {
    return parser.decode(qs.parse(queryString));
  }, [queryString, parser]);
  var holder = useRef(queryParams);
  useEffect(function () {
    holder.current = queryParams;
  });
  var setQueryParams = useCallback(function (newQueryParamsOrCb) {
    var currentQueryParams = holder.current;
    var nextParams;

    if (typeof newQueryParamsOrCb === 'function') {
      nextParams = newQueryParamsOrCb(currentQueryParams);
    } else {
      nextParams = _objectSpread(_objectSpread({}, currentQueryParams), newQueryParamsOrCb);
    }

    var queryString = qs.stringify(parser.encode(nextParams), opts);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    setQueryString.apply(void 0, [queryString].concat(args));
  }, [parser, opts, setQueryString]);
  return [queryParams, setQueryParams];
}

export default useQueryParams;
